import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'gbDisplayName',
})
export class GbDisplayNamePipe implements PipeTransform {
  constructor() {}

  transform(profile?: any): string {
    if (!profile) return ''

    const keys = ['first_name', 'email', 'invite_email', 'phone_number', 'invite_phone_number']

    const key = keys.find((k) => profile[k])

    if (key === 'first_name' && profile.last_name) {
      return `${profile.first_name} ${profile.last_name}`
    }

    return key ? profile[key] : ''
  }
}
